import { render, staticRenderFns } from "./BizApp.vue?vue&type=template&id=6389be94&"
import script from "./BizApp.vue?vue&type=script&lang=js&"
export * from "./BizApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports